module.exports = __webpack_public_path__ + "static/Green_Dragon-00367e26ddecea41f857bfe9ccf63628.jpg";